import { isOpenDeal, STAGE_LABEL, STAGE_ORDER } from './logic';
import { ME } from './pipeline';
import type { Deal, DealStage } from './types';

// Mint-Pipeline-iPad / -Phone: logic thuần (phễu, tỷ lệ chốt, đoạn của điện thoại, thẻ chi tiết). Không tiền.

export type Scope = 'mine' | 'team';

export const scopeDeals = (rows: readonly Deal[], scope: Scope, canTeam: boolean): Deal[] =>
  rows.filter((d) => scope === 'team' && canTeam ? true : d.sale === ME);

/** Phễu: số phiếu theo giai đoạn (chỉ đoạn có phiếu mới có thanh). */
export const funnel = (rows: readonly Deal[]): { stage: DealStage; label: string; n: number }[] =>
  STAGE_ORDER.map((stage) => ({ stage, label: STAGE_LABEL[stage], n: rows.filter((d) => d.stage === stage).length }));

/** Tỷ lệ chốt = Won / (Won + Lost), làm tròn %. */
export function winRate(rows: readonly Deal[]): string {
  const w = rows.filter((d) => d.stage === 'Won').length;
  const l = rows.filter((d) => d.stage === 'Lost').length;
  return `${w + l ? Math.round((w / (w + l)) * 100) : 0}%`;
}

export const openCount = (rows: readonly Deal[]): number => rows.filter(isOpenDeal).length;

/** Đoạn của điện thoại: Mới · Chờ giá · Đã báo · Đóng (Won + Lost). */
export type Seg = 'New' | 'Pricing' | 'Quoted' | 'closed';
export const SEGS: readonly { key: Seg; label: string }[] = [
  { key: 'New', label: 'Mới' },
  { key: 'Pricing', label: 'Chờ giá' },
  { key: 'Quoted', label: 'Đã báo' },
  { key: 'closed', label: 'Đóng' },
];
export const inSeg = (d: Deal, seg: Seg): boolean => (seg === 'closed' ? d.stage === 'Won' || d.stage === 'Lost' : d.stage === seg);

/** Lý do Lost + tuỳ chọn ngày follow của bảng trượt (board). */
export const LOST_REASONS = ['Giá', 'Lịch tàu', 'Dịch vụ', 'Khách huỷ', 'Khác'] as const;
export const FOLLOW_OPTS = ['Hôm nay · 22/Oct', '+2 ngày làm việc · 26/Oct', '+5 ngày làm việc · 29/Oct', 'Không follow'] as const;
/** JobID hợp lệ (board): SE260639171. */
export const isJobId = (s: string): boolean => /^[SA][EILT]\d{9}$/.test(s.trim());
